import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { v1 } from 'uuid';
import { PropTypes as PropTypes$1 } from '@micromag/core';
import { LinkStyle, HighlightStyle } from '@micromag/core/components';
import { getStyleFromLink, getStyleFromHighlight, getStyleFromText, getStyleFromMargin } from '@micromag/core/utils';

var styles = {"container":"micromag-element-quote-container","showEmpty":"micromag-element-quote-showEmpty"};

var propTypes = {
  body: PropTypes.string,
  textStyle: PropTypes$1.textStyle,
  linksStyle: PropTypes$1.textStyle,
  margin: PropTypes$1.margin,
  showEmpty: PropTypes.bool,
  className: PropTypes.string,
  emptyClassName: PropTypes.string
};
var defaultProps = {
  body: null,
  textStyle: null,
  linksStyle: null,
  margin: null,
  showEmpty: false,
  className: null,
  emptyClassName: null
};
var Quote = function Quote(_ref) {
  var body = _ref.body,
    textStyle = _ref.textStyle,
    linksStyle = _ref.linksStyle,
    margin = _ref.margin,
    showEmpty = _ref.showEmpty,
    className = _ref.className,
    emptyClassName = _ref.emptyClassName;
  var _ref2 = textStyle || {},
    _ref2$link = _ref2.link,
    linkStyle = _ref2$link === void 0 ? null : _ref2$link,
    _ref2$highlight = _ref2.highlight,
    highlightStyle = _ref2$highlight === void 0 ? null : _ref2$highlight;
  var finalStyle = {};
  var finalLinkStyle = linkStyle !== null ? getStyleFromLink(linkStyle) : null;
  var finalHighlightStyle = highlightStyle !== null ? getStyleFromHighlight(highlightStyle) : null;
  if (textStyle !== null) {
    finalStyle = _objectSpread(_objectSpread({}, finalStyle), getStyleFromText(textStyle));
  }
  if (margin !== null) {
    finalStyle = _objectSpread(_objectSpread({}, finalStyle), getStyleFromMargin(margin));
  }
  if (linksStyle !== null) {
    finalLinkStyle = _objectSpread(_objectSpread({}, finalLinkStyle), getStyleFromText(linksStyle));
  }
  var id = useMemo(function () {
    return finalLinkStyle !== null ? "quote-component-".concat(v1()) : null;
  }, [finalLinkStyle !== null]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, finalLinkStyle !== null ? /*#__PURE__*/React.createElement(LinkStyle, {
    selector: "#".concat(id),
    style: finalLinkStyle
  }) : null, finalHighlightStyle !== null ? /*#__PURE__*/React.createElement(HighlightStyle, {
    selector: "#".concat(id),
    style: finalHighlightStyle
  }) : null, /*#__PURE__*/React.createElement("blockquote", {
    id: id,
    className: classNames([styles.container, _defineProperty(_defineProperty(_defineProperty({}, styles.showEmpty, showEmpty), emptyClassName, showEmpty && emptyClassName !== null), className, className !== null)]),
    style: finalStyle,
    dangerouslySetInnerHTML: {
      __html: body
    }
  }));
};
Quote.propTypes = propTypes;
Quote.defaultProps = defaultProps;

export { Quote as default };
